<template>
    <div>
        <el-dialog :title="title[sourceType]" :visible.sync="sourceBoxVisible" custom-class="preBigSourceBoxClass" :close-on-click-modal="false" :destroy-on-close="true" @close="closed">
            <div class="preImgVideoAudioBox">
                <!-- 图片 -->
                <div v-if="sourceType=='image' && sourceBoxVisible" class="preBigSource preBigImg myflex-lv" ref="preBigImg">
                    <img class="preBigImg-innerimg" ref="preBigImgInnerimg" :src="sourceUrl" onmousemove="event.preventDefault()"/>
                </div>
                <!-- 视频 -->
                <video v-else-if="sourceType=='video' && sourceBoxVisible" ref="preBigVideo" class="preBigSource preBigVideo" preload="auto" autoplay="autoplay" controls :src="sourceUrl"></video>
                <!-- 音频 -->
                <audio v-else-if="sourceType=='audio' && sourceBoxVisible" ref="preBigAudio" class="preBigSource preBigAudio" preload="auto" autoplay="autoplay" controls :src="sourceUrl"></audio>
            </div>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.preImgVideoAudioBox{width:100%;height:560px;overflow:hidden;background:#eee;}
.preBigSourceBox{background:#ebebeb;width:100%;height:100%;padding:0;}
.preBigSource{background-size:contain !important;width:100%;height:100%;}
.preBigVideo{background:#000;}
.preBigAudio{height:auto;}
.preBigImg{text-align:center;overflow:hidden;position:relative;}
.preBigImg-innerimg{max-width:100%;max-height:100%;-webkit-transition:all 0s;transition:all 0s;cursor:move;position:absolute;}
</style>

<script>

export default {
    name: "preSource",
    components: {

    },
    prop:{
        visible:{
            default: false,
        },
        url: {
            default:'',
        },
        type: {
            default: '',
        },
    },
    data(){
        return {
            art: art,
            // sourceBoxVisible: this.visible,
            // sourceUrl: art.addOssurlHeader(this.url),
            // sourceType: this.type,
            sourceBoxVisible: false,
            sourceUrl: '',
            sourceType: '',
            title: {
                'image': '图片预览',
                'video': '视频预览',
                'audio': '音频预览',
            }
        }
    },
    methods:{
        //show
        show(url,type){
            console.log(url,type);
            this.sourceBoxVisible = true;
            this.sourceUrl = url;
            this.sourceType = type;
            if( type=='image' ){
                setTimeout(()=>{
                    //this.initPosition();
                    this.initWheel();
                },10)
            }
        },

        closed(){
            console.log();
            //this.$refs.preBigVideo.pause();
            //this.$refs.preBigAudio.pause();
        },

        //initPosition
        initPosition(){
            var myimage = this.$refs.preBigImgInnerimg;
            var imgBox = this.$refs.preBigImg;
            var w = myimage.offsetWidth;
            var h = myimage.offsetHeight;
            myimage.style.top = ((560-h)/2)+'px';
            myimage.style.left = ((760-w)/2)+'px';
            myimage.style.webkitTransform = 'scale(1)';
            myimage.style.transform = 'scale(1)';
            myimage.style.zoom = '100%';
        },

        //初始化鼠标滚动事件
        initWheel(){
            //如果是图片，添加鼠标缩放功能
            if (this.sourceType == 'image') {
                var myimage = this.$refs.preBigImgInnerimg;
                var imgBox = this.$refs.preBigImg;
                //监听滚动鼠标事件
                if (imgBox.addEventListener) {
                    imgBox.addEventListener("mousewheel", imgZoom, false); // IE9, Chrome, Safari, Opera
                    imgBox.addEventListener("DOMMouseScroll", imgZoom, false); // Firefox
                }
                //zoom（兼容性不好）
                function imgZoom1() {
                    var obj = myimage;
                    //“event.wheelDelta” 属性值：返回的值，如果是正值说明滚轮是向上滚动，
                    //如果是负值说明滚轮是向下滚动；返回的值，均为 120 的倍数，
                    var zoom = parseInt(obj.style.zoom, 10) || 100;
                    console.log(zoom, 'zoom1');
                    zoom += event.wheelDelta / 12;
                    if (zoom > 0)obj.style.zoom = zoom + '%';
                    event.preventDefault();
                    return false;
                }
                //scale（推荐）
                function imgZoom() {
                    var obj = myimage;
                    var scale = obj.style.transform;
                    var zoom = scale.substring(scale.indexOf("(") + 1, scale.indexOf(")")) * 1 || 1;
                    zoom += event.wheelDelta / 1200;
                    if (zoom > 0) {
                        zoom = (zoom > 5 ? 5 : zoom);
                        zoom = (zoom < .2 ? .2 : zoom);
                        obj.style.webkitTransform = 'scale(' + zoom + ')';
                        obj.style.transform = 'scale(' + zoom + ')';
                    }
                    event.preventDefault();
                    return false;
                }
                //鼠标拖动图片
                myimage.onmousedown = mouseDown;

                function mouseDown(event) {
                    event.preventDefault();
                    /*再次点击时使得图标任然在那个位置，鼠标可以点击到图标上*/
                    var ol = event.clientX - myimage.offsetLeft;
                    var ot = event.clientY - myimage.offsetTop;
                    /*鼠标拖动*/
                    myimage.onmousemove = mouseMove;

                    function mouseMove(event) {
                        event.preventDefault();
                        
                        var left = event.clientX - ol;
                        var top = event.clientY - ot;
                        var w = myimage.offsetWidth * -0.8;
                        var h = myimage.offsetHeight * -0.8;
                        myimage.style.left = (left > w ? left : w) + 'px';
                        myimage.style.top = (top > h ? top : h) + 'px';
                        return false;
                    }
                    /*鼠标松开*/
                    window.onmouseup = mouseUp;

                    function mouseUp(event) {
                        console.log('up');
                        myimage.onmousemove = null;
                        window.onmouseup = null;
                    }
                }

            }
        },
    },
    created(){

    },
    mounted(){
        
    }
};
</script>
